import React, {FC} from "react"
import {get} from "lodash"
import isValidDomain from "is-valid-domain"

import {FormattedMessage, InjectIntl, injectIntl} from "@irati/utils/lang"
import {ValidationButton} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import Loading from "@irati/ui/src/Loading"
import authentication from "@irati/auth"
import {Body} from "@irati/ui/src/Typography"

import {EMAIL, EMAIL_VALIDATION_DESCRIPTION, WELCOME_MESSAGE, INVALID_DOMAINS} from "../../../../constants/selfSignUp"
import AddRemoveInputList from "./AddRemoveInputList"
import SignUpOption from "./SignUpOption"
import WelcomeMessage from "./WelcomeMessage"

const emailSchema = Validation.string("admin.components.emailDomain.emailSchema.validation.isRequired")
  .test({
    name: "validDomain",
    message: "admin.components.emailDomain.emailSchema.validation.message",
    test: (value) => isValidDomain(value)
  })
  .notOneOf(INVALID_DOMAINS, "admin.components.emailDomain.emailSchema.validation.invalidDomain")

interface Props extends InjectIntl {
  show: boolean
  selfSignUp: () => void
  onSelect: (email: string) => void
  onChange: (property: string, value: string) => void
  onSubmit: () => void
  submit?: Promise<any>
}

const EmailDomain: FC<Props> = ({show, submit, selfSignUp, onSelect, onChange, onSubmit, formatMessage}) => {
  const updateWelcomeMessage = (welcomeMessage: string) => {
    onChange("welcomeMessage", welcomeMessage)
  }

  const updateEmails = (keys: string[]) => {
    const config = get(selfSignUp, "config", {})
    config[EMAIL] = {keys}

    onChange("method", EMAIL)
    onChange("config", config)
  }

  const handleSubmit = () => {
    onChange("method", EMAIL)
    onSubmit()
  }

  return (
    <SignUpOption
      id="settingsSelfSignup_emailDomain_option_button"
      title={formatMessage({id: "admin.components.emailDomain.signUpOption.title"})}
      description={`${formatMessage({id: EMAIL_VALIDATION_DESCRIPTION})}
        ${`${authentication.business().subdomain}.perkbox.com/signup`}`}
      onClick={() => onSelect(EMAIL)}
      active={show}>
      <AddRemoveInputList
        update={updateEmails}
        inputs={get(selfSignUp, "config.EMAIL.keys", [null])}
        label={formatMessage({id: "admin.components.emailDomain.addRemoveInputList.label"})}
        addButtonText={formatMessage({id: "admin.components.emailDomain.addRemoveInputList.addButtonText"})}
        validation={emailSchema}
      />
      <Body small marginBottom={1}>
        <FormattedMessage id="admin.components.emailDomain.email.example" />
      </Body>
      <WelcomeMessage
        updateWelcomeMessage={updateWelcomeMessage}
        welcomeMessage={get(selfSignUp, "welcomeMessage", formatMessage({id: WELCOME_MESSAGE}))}
      />
      <Loading load={submit} useLoader={false} />
      <ValidationButton primary full large load={submit} onClick={handleSubmit}>
        <FormattedMessage id="admin.components.emailDomain.validationButton.save" />
      </ValidationButton>
    </SignUpOption>
  )
}

export default injectIntl(EmailDomain)
